module.exports = __webpack_public_path__ + "static/media/porteirabertaLOGOCOLOR.ca95ccbf.png";